import { axios } from "../utils/axios";
import { toast } from "react-toastify";
import { toastOptions } from "../config/toast";
import { useGeneralAppStore } from "../store/generalAppStore";
import { isAxiosError } from "axios";

const { handlerLoading, handlerModal } = useGeneralAppStore.getState();

//^TRAE LAS ACTAS ASIGNADAS A UN INSPECTOR
export const getActasInspector = async (estadoId) => {
  handlerLoading({ loading: true, loadName: "actas_inspector" });
  try {
    const response = await axios().get("solicitudes_inspector", {
      params: { estado_id: estadoId },
    });
    if (!isAxiosError(response)) {
      const { data, error } = response.data;
      if (error) toast.error(error, toastOptions);
      return data;
    }
  } catch (error) {
    toast.error("Hubo un error en la consulta", toastOptions);
  } finally {
    handlerLoading({ loading: false, loadName: "actas_inspector" });
  }
};

//^TRAE EL DETALLE DE UN ACTA
export const getActa = async (payload) => {
  handlerLoading({ loading: true, loadName: "acta_inspector" });
  try {
    const response = await axios().get(`acta/${payload}`);
    if (!isAxiosError(response)) {
      const { data, error } = response.data;
      if (error) toast.error(error, toastOptions);
      return data;
    }
  } catch (error) {
    toast.error("Hubo un error en la consulta", toastOptions);
  } finally {
    handlerLoading({ loading: false, loadName: "acta_inspector" });
  }
};

//^CAMBIA UN ACTA A CANCELADA
export const cancelarActa = async (payload) => {
  handlerLoading({ loading: true, loadName: "cambiar_estado" });
  try {
    const response = await axios().get(`acta/cancelar_acta/${payload}`);
    if (!isAxiosError(response)) {
      const { data, error } = response.data;
      if (error) toast.error(error, toastOptions);
      toast.error("El acta fue cancelada", toastOptions);
      handlerModal({ modal: false, modalName: "cancelar_acta" });
      return data;
    }
  } catch (error) {
    toast.error("Hubo un error en la consulta", toastOptions);
  } finally {
    handlerLoading({ loading: false, loadName: "cambiar_estado" });
  }
};

//^PUEDE SUBIR UNA CONSTATACION
export const enviarConstatacion = async (payload) => {
  const formData = new FormData();

  if (payload.acta_id) {
    formData.append("acta_id", payload.acta_id);
  }
  if (payload.constatacion_file.length > 0) {
    formData.append("constatacion_file", payload.constatacion_file[0]);
  }
  if (payload.numero_acta) {
    formData.append("numero_acta", payload.numero_acta);
  }
  if (payload.descripcion_tarea) {
    formData.append("descripcion_tarea", payload.descripcion_tarea);
  }
  if (payload.constatacion_dano) {
    formData.append("constatacion_dano", payload.constatacion_dano);
  }
  if (payload.observacion) {
    formData.append("observacion", payload.observacion);
  }

  handlerLoading({ loading: true, loadName: "enviar_constatacion" });
  try {
    const response = await axios().post(`constatacion`, formData);
    if (!isAxiosError(response)) {
      const { data, error } = response.data;
      if (error) toast.error(error, toastOptions);
      toast.success("Constatación enviada correctamente", toastOptions);
      return data;
    }
  } catch (error) {
    toast.error("Hubo un error en la consulta", toastOptions);
  } finally {
    handlerLoading({ loading: false, loadName: "enviar_constatacion" });
  }
};
